import ServiceRestApi from "./service-rest-api";
 
class FoldersManagementService {
 
    getFolders = () => {
        return ServiceRestApi.get("/api/folders");
    }
 
    getFolderDetails = (folderId) => {
        return ServiceRestApi.get("/api/folder?folder-id="+folderId);
    }
 
    getFolderPrerequisites = () => {
        return ServiceRestApi.get("/api/folder-prerequisites");
    }
 
    addNewFolder = (folder) => {
        return ServiceRestApi.post("/api/folder", folder);
    }
 
    updateFolder = (folder) => {
        return ServiceRestApi.post("/api/folder", folder);
    }
 
 
    deleteFolder = (data) => {
        return ServiceRestApi.delete("/api/folder?folder-id=" + data);
    }
}
 
export default new FoldersManagementService();